import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { getDiscountedPrice } from '../utils/deviations';
import { formatDollars, OPTIONAL_DECIMAL_DIGITS } from '../utils/formatting';
import DiscountLabel from '../DiscountLabel';
import s from './PriceWithDiscount.scss';
const formatDollarsOptions = _object_spread_props(_object_spread({}, OPTIONAL_DECIMAL_DIGITS), {
    useGrouping: true
});
const PriceWithDiscount = (_param)=>{
    var { className, dollarAmount, eligibleDiscount, size = 'medium', variant = 'regular', prefix, infix } = _param, discountLabelProps = _object_without_properties(_param, [
        "className",
        "dollarAmount",
        "eligibleDiscount",
        "size",
        "variant",
        "prefix",
        "infix"
    ]);
    const { t } = useTranslation();
    dollarAmount = parseFloat(`${dollarAmount}`);
    const { price, discountedPrice } = getDiscountedPrice(dollarAmount, eligibleDiscount);
    const formattedDollarAmount = formatDollars(price, formatDollarsOptions);
    const formattedDollarAmountAfterDiscount = formatDollars(discountedPrice, formatDollarsOptions);
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], s[size], s[variant], className)
    }, prefix, eligibleDiscount && size !== 'small' && /*#__PURE__*/ React.createElement(React.Fragment, null, t('priceWithDiscount.price', {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        price: /*#__PURE__*/ React.createElement("div", {
            className: s['price']
        }, formattedDollarAmountAfterDiscount),
        priceBeforeDiscount: /*#__PURE__*/ React.createElement("div", {
            className: c(s['old-price'])
        }, formattedDollarAmount)
    }), infix, /*#__PURE__*/ React.createElement(DiscountLabel, _object_spread({
        className: s['discount-label'],
        discount: eligibleDiscount,
        size: size
    }, discountLabelProps))), (!eligibleDiscount || size === 'small') && t('priceWithDiscount.price', {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        price: /*#__PURE__*/ React.createElement("div", {
            className: s['price']
        }, formattedDollarAmount)
    }));
};
PriceWithDiscount.displayName = 'PriceWithDiscount';
export default PriceWithDiscount;

//# sourceMappingURL=PriceWithDiscount.js.map